__turbopack_context__.v({
  "className": "montserrat_37ce41fd-module__SgDVtq__className",
});
